module.exports = __webpack_public_path__ + "img/lqsxback_5.14b88e74.svg";